export const TEAM_MEMBER_ROLES = [
  {
    label: 'MEMBER',
    value: 'MEMBER',
  },
  {
    label: 'OWNER',
    value: 'OWNER',
  },
  {
    label: 'DOCTOR',
    value: 'DOCTOR',
  },
  {
    label: 'NURSE',
    value: 'NURSE',
  },
  {
    label: 'ACCOUNTANT',
    value: 'ACCOUNTANT',
  },
  {
    label: 'RECEPTIONIST',
    value: 'RECEPTIONIST',
  },
];

export const TEAM_MEMBER_ROLE_LABELS = {
  MEMBER: 'MEMBER',
  OWNER: 'OWNER',
  DOCTOR: 'DOCTOR',
  NURSE: 'NURSE',
  ACCOUNTANT: 'ACCOUNTANT',
  RECEPTIONIST: 'RECEPTIONIST',
};
